import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { audiences } from '../../mockData';
import './Agency.css';

function AgencyAudience() {
  const { Title } = Typography;

  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Size', dataIndex: 'size', key: 'size', align: 'right', render: (v) => v.toLocaleString() },
    { title: 'Type', dataIndex: 'type', key: 'type', render: (t) => <Tag>{t}</Tag> },
  ];

  return (
    <div className="agency-audience-agency">
      <Title level={3}>Agency Audience Database</Title>
      <Table rowKey="id" columns={columns} dataSource={audiences.agency} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default AgencyAudience;
